import { API } from "@/app/api/BaseAPI";
import {Convert, TokenEntity} from "@/app/entity/TokenEntity"

export class TokenAPI {
  readonly getPath = '/user/getToken';
  readonly refreshPath = '/user/refreshToken';

  async getToken(username: string, password: string): Promise<TokenEntity> {
    const api = new API();

    try {
      // 创建 FormData 对象
      const formData = new FormData();
      formData.append('username', username);
      formData.append('password', password);

      const response = await api
          .withPath(this.getPath)
          .withBody(formData)
          .withMethod("POST")
          .request();
      if (response.data !== '') {
        return Convert.toTokenEntity(response.data);
      } else {
        throw new Error(response.data);
      }
    } catch (reason: any) {
      // 如果是axios错误，保留HTTP状态码信息
      if (reason.response && reason.response.status) {
        const error = new Error(reason.message || 'Request failed');
        (error as any).status = reason.response.status;
        (error as any).response = reason.response;
        throw error;
      }
      throw reason;
    }
  }


  async refreshToken(): Promise<TokenEntity> {
    const api = new API();

    // 创建 FormData 对象
    const formData = new FormData();
    formData.append('refresh_token', localStorage.getItem("refresh_token") || '');

    const response = await api
        .withPath(this.refreshPath)
        .withBody(formData)
        .withMethod("POST")
        .request();
    return Convert.toTokenEntity(response.data);
  }
}
